import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { generateTable } from '../../table/Table';
import { fetchForms, fetchFormTypes } from '../../../apis';
import t from 'prop-types';
import { defineKqlQuery } from '../../../helpers';
import { generatePaginationParams, generateSortParams } from '../../../apis/http';
var VALID_FORM_STATUES = ['New', 'Active', 'Inactive', 'Delete'].map(function (s) {
  return {
    value: s,
    label: s
  };
});

var filterDataSources = function filterDataSources(_ref) {
  var kappSlug = _ref.kappSlug;
  return {
    types: {
      fn: fetchFormTypes,
      params: kappSlug && [{
        kappSlug: kappSlug
      }],
      transform: function transform(result) {
        return result.formTypes.map(function (type) {
          return {
            label: type.name,
            value: type.name
          };
        });
      }
    }
  };
};

var filters = function filters(_ref2) {
  var kappSlug = _ref2.kappSlug;
  return function (_ref3) {
    var types = _ref3.types;
    return (!kappSlug || types) && [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }, {
      name: 'slug',
      label: 'Slug',
      type: 'text'
    }, kappSlug && {
      name: 'type',
      label: 'Type',
      type: 'select',
      options: types
    }, {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: function options() {
        return VALID_FORM_STATUES;
      }
    }, {
      name: 'updatedBy',
      label: 'Updated By',
      type: 'user',
      serialize: function serialize(_ref4) {
        var values = _ref4.values;
        return values.getIn(['updatedBy', 'username']);
      }
    }];
  };
};

var formQuery = defineKqlQuery().matches('name', 'name').matches('slug', 'slug').startsWith('updatedBy', 'updatedBy').equals('type', 'type').equals('status', 'status').end();

var dataSource = function dataSource(_ref5) {
  var _ref5$kappSlug = _ref5.kappSlug,
      kappSlug = _ref5$kappSlug === void 0 ? null : _ref5$kappSlug,
      datastore = _ref5.datastore,
      _ref5$manage = _ref5.manage,
      manage = _ref5$manage === void 0 ? false : _ref5$manage,
      _ref5$surveyList = _ref5.surveyList,
      surveyList = _ref5$surveyList === void 0 ? false : _ref5$surveyList;
  return {
    fn: fetchForms,
    params: function params(paramData) {
      return [_objectSpread(_objectSpread(_objectSpread({}, generateSortParams(paramData)), generatePaginationParams(paramData)), {}, {
        q: formQuery(paramData.filters.toJS()),
        include: "details".concat(datastore ? ',indexDefinitions,backgroundJobs' : ''),
        datastore: datastore,
        kappSlug: kappSlug,
        manage: manage
      })];
    },
    transform: function transform(result) {
      return {
        data: surveyList ? result.forms.filter(function (f) {
          return f.type === 'Survey';
        }) : result.forms,
        nextPageToken: result.nextPageToken
      };
    }
  };
};

var columns = [{
  value: 'name',
  title: 'Name',
  sortable: true
}, {
  value: 'slug',
  title: 'Slug',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}, {
  value: 'createdBy',
  title: 'Created By'
}, {
  value: 'updatedAt',
  title: 'Updated At',
  sortable: true
}, {
  value: 'updatedBy',
  title: 'Updated By',
  sortable: true
}, {
  value: 'notes',
  title: 'Notes'
}, {
  value: 'status',
  title: 'Status',
  sortable: true
}, {
  value: 'type',
  title: 'Type',
  sortable: true,
  filter: 'startsWith',
  type: 'text'
}, {
  value: 'submissionLabelExpression',
  title: 'Submission Label'
}];
export var FormTable = generateTable({
  tableOptions: ['kappSlug', 'datastore', 'manage', 'surveyList'],
  columns: columns,
  filters: filters,
  filterDataSources: filterDataSources,
  dataSource: dataSource
});
FormTable.defaultProps = {};
FormTable.displayName = 'FormTable';
FormTable.propTypes = {
  /** Kapp Slug of associated forms to render.  */
  kappSlug: t.string,

  /** If datastore forms should be rendered.  */
  datastore: t.bool
};